import { useState, type FC } from 'react';

import type { Register, RegisterDialogData } from '../../../../types/helsenorge.helseregistre.internalapi.entities.entities';
import type { RegisterDialogType } from '../../../../types/helsenorge.helseregistre.internalapi.entities.enums';
import type { HNHelseregistreJS } from '../../../../types/Resources';

import Button from '@helsenorge/designsystem-react/components/Button';
import Checkbox from '@helsenorge/designsystem-react/components/Checkbox';
import Loader from '@helsenorge/designsystem-react/components/Loader';
import Modal from '@helsenorge/designsystem-react/components/Modal';
import Spacer from '@helsenorge/designsystem-react/components/Spacer';

import { BestillingerStatusILightBox } from './bestillinger-status-i-lightbox';
import { useAppDispatch } from '../../../store/hooks';
import { SendInnsynBestilling } from '../register-melding';
import { getHashForInnsynDialogType, getDialogTypeBeskrivelse } from '../utils';

export interface Props {
  resources: HNHelseregistreJS;
  dialogTypes: RegisterDialogData[] | null;
  register: Register;
  loading: boolean;

  closeDialogModal: () => void;
}

const InnsynForesporselModal: FC<Props> = ({ resources, register, loading, closeDialogModal, dialogTypes }) => {
  const dispatch = useAppDispatch();

  const [selectedDialogTyper, setSelectedDialogTyper] = useState<RegisterDialogType[]>([]);

  const onChangeSelectedInnsyn = (e: RegisterDialogData): void => {
    const dialogerUtenomDenValgte = selectedDialogTyper.filter(dialogType => dialogType !== e.dialogType);

    if (dialogerUtenomDenValgte.length === selectedDialogTyper.length) {
      setSelectedDialogTyper([...selectedDialogTyper, e.dialogType]);
    } else {
      setSelectedDialogTyper(dialogerUtenomDenValgte);
    }
  };

  const sendInnsynBestilling = (): void => {
    dispatch(SendInnsynBestilling(selectedDialogTyper, register, getHashForInnsynDialogType(dialogTypes)));
    setSelectedDialogTyper([]);
  };

  return (
    <Modal
      onClose={(): void => {
        closeDialogModal();
        setSelectedDialogTyper([]);
      }}
      title={resources.bestillInnsynLightBoxHeader}
      disableCloseEvents
    >
      <>
        {loading && <Loader overlay="screen" />}
        <BestillingerStatusILightBox dialogTypes={dialogTypes} resources={resources} />
        <Spacer size="m" />
        {dialogTypes &&
          dialogTypes.map((e: RegisterDialogData, i: number) => {
            const checked = selectedDialogTyper.some(function (n: RegisterDialogType) {
              return n === e.dialogType;
            });
            return (
              <>
                <Checkbox
                  label={getDialogTypeBeskrivelse(e.dialogType, resources) ?? ''}
                  inputId={`dialog-${i}`}
                  key={`${e.dialogType}-${e.forespurtTid}`}
                  disabled={e.blokkert}
                  checked={checked}
                  onChange={(): void => onChangeSelectedInnsyn(e)}
                />
                <Spacer />
              </>
            );
          })}
        <Spacer size={'s'} />
        <Button disabled={selectedDialogTyper.length === 0 || loading} onClick={sendInnsynBestilling}>
          {resources.bestillInnsynBestill}
        </Button>
        <Spacer />
      </>
    </Modal>
  );
};

export default InnsynForesporselModal;
